<!-- Executed Contract Upload — SkyPlus -->
<div class="sp-dashboard-container">

  <!-- HEADER -->
  <sp-header></sp-header>

  <!-- MAIN -->
  <main class="sp-main">

    <!-- Breadcrumb / header -->
    <div class="sp-page-header">
      <div class="breadcrumb">
        <button class="btn-back" (click)="goBack()"><span class="material-icons">arrow_back</span></button>
        <span class="breadcrumb-item clickable" (click)="goBack()">Contracts</span>
        <span class="material-icons breadcrumb-sep">chevron_right</span>
        <span class="breadcrumb-item current">Upload Executed Contract</span>
      </div>
      <div class="page-title-block">
        <h1><span class="material-icons page-icon">upload_file</span>Upload Executed Contract</h1>
        <p>For contracts signed externally — skips the review workflow and goes straight to Active management.</p>
      </div>
    </div>

    <!-- Success -->
    <div class="alert-success" *ngIf="successMessage">
      <span class="material-icons">check_circle</span> {{ successMessage }}
    </div>

    <!-- Error -->
    <div class="alert-error" *ngIf="saveError">
      <span class="material-icons">error_outline</span> {{ saveError }}
    </div>

    <div class="upload-form-layout">

      <!-- ═══ LEFT COLUMN ════════════════════════════════════════════════════ -->
      <div class="form-column primary-column">

        <!-- File drop zone -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">attach_file</span> Contract Document <span class="required-badge">Required</span></div>

          <div class="drop-zone" [class.drag-over]="isDragOver" [class.has-file]="!!selectedFile"
               (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
               (click)="triggerFilePicker()">
            <input #fileInput type="file" accept=".pdf,.docx,.doc,.png,.jpg,.jpeg" (change)="onFileSelected($event)" style="display:none">
            <ng-container *ngIf="!selectedFile">
              <span class="material-icons drop-icon">cloud_upload</span>
              <p class="drop-label">Drag & drop the signed contract here</p>
              <p class="drop-sub">or <strong>click to browse</strong> — PDF, DOCX, or image</p>
            </ng-container>
            <ng-container *ngIf="selectedFile">
              <span class="material-icons drop-icon success-icon">description</span>
              <p class="drop-label file-name">{{ filePreviewName }}</p>
              <p class="drop-sub">{{ fileSizeFormatted }} — <a (click)="$event.stopPropagation(); removeFile()">Remove</a></p>
            </ng-container>
          </div>
        </div>

        <!-- Contract Identity -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">badge</span> Contract Identity</div>
          <div class="form-grid">
            <div class="form-group full-width">
              <label>Contract Title <span class="req">*</span></label>
              <input type="text" [(ngModel)]="form.contractTitle" placeholder="e.g. Supply of Office Equipment" class="form-control">
            </div>
            <div class="form-group">
              <label>Contract Type <span class="req">*</span></label>
              <select [(ngModel)]="form.contractType" class="form-control">
                <option *ngFor="let t of contractTypes" [value]="t.value">{{ t.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Contract Number <span class="hint">(auto-generated if blank)</span></label>
              <input type="text" [(ngModel)]="form.contractNumber" placeholder="e.g. CT-2025-00042" class="form-control">
            </div>
          </div>
        </div>

        <!-- Parties -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">handshake</span> Parties</div>
          <div class="form-grid">
            <div class="form-group">
              <label>Supplier / Counterparty <span class="req">*</span></label>
              <input type="text" [(ngModel)]="form.supplierName" placeholder="Supplier or company name" class="form-control">
            </div>
            <div class="form-group">
              <label>Our Company Name</label>
              <input type="text" [(ngModel)]="form.companyName" placeholder="Bandari DT Sacco" class="form-control">
            </div>
            <div class="form-group">
              <label>Department</label>
              <select [(ngModel)]="form.departmentName" class="form-control">
                <option value="">Select department</option>
                <option *ngFor="let d of departments" [value]="d">{{ d }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Financial -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">payments</span> Financial</div>
          <div class="form-grid">
            <div class="form-group">
              <label>Contract Amount</label>
              <input type="number" [(ngModel)]="form.contractAmount" placeholder="0.00" min="0" class="form-control">
            </div>
            <div class="form-group">
              <label>Currency</label>
              <select [(ngModel)]="form.currency" class="form-control">
                <option *ngFor="let c of currencies" [value]="c">{{ c }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Dates -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">calendar_today</span> Key Dates</div>
          <div class="form-grid">
            <div class="form-group">
              <label>Signing Date</label>
              <input type="date" [(ngModel)]="form.signingDate" class="form-control">
            </div>
            <div class="form-group">
              <label>Effective Date</label>
              <input type="date" [(ngModel)]="form.effectiveDate" class="form-control">
            </div>
            <div class="form-group">
              <label>Expiry Date <span class="hint">(needed for reminders)</span></label>
              <input type="date" [(ngModel)]="form.expiryDate" (change)="generateDefaultReminders()" class="form-control">
            </div>
          </div>
        </div>

        <!-- Type-specific: Purchase -->
        <div class="form-card" *ngIf="showPurchaseFields">
          <div class="card-header"><span class="material-icons">inventory_2</span> Purchase Details</div>
          <div class="form-grid">
            <div class="form-group"><label>Payment Terms</label><input type="text" [(ngModel)]="form.paymentTerms" class="form-control" placeholder="e.g. 30 days net"></div>
            <div class="form-group"><label>Delivery Terms</label><input type="text" [(ngModel)]="form.deliveryTerms" class="form-control" placeholder="e.g. CIF Nairobi"></div>
            <div class="form-group"><label>Warranty Period (months)</label><input type="number" [(ngModel)]="form.warrantyPeriod" class="form-control" min="0"></div>
          </div>
        </div>

        <!-- Type-specific: Service -->
        <div class="form-card" *ngIf="showServiceFields">
          <div class="card-header"><span class="material-icons">build</span> Service Details</div>
          <div class="form-grid">
            <div class="form-group full-width"><label>Service Description</label><textarea [(ngModel)]="form.serviceDescription" class="form-control" rows="3"></textarea></div>
            <div class="form-group"><label>SLA Terms</label><input type="text" [(ngModel)]="form.slaTerms" class="form-control"></div>
            <div class="form-group"><label>Payment Terms</label><input type="text" [(ngModel)]="form.paymentTerms" class="form-control"></div>
          </div>
        </div>

        <!-- Type-specific: NDA -->
        <div class="form-card" *ngIf="showNdaFields">
          <div class="card-header"><span class="material-icons">lock</span> NDA Details</div>
          <div class="form-grid">
            <div class="form-group"><label>Confidentiality Period (months)</label><input type="number" [(ngModel)]="form.confidentialityPeriod" class="form-control" min="1"></div>
            <div class="form-group"><label>Disclosing Party</label><input type="text" [(ngModel)]="form.disclosingParty" class="form-control"></div>
            <div class="form-group"><label>Receiving Party</label><input type="text" [(ngModel)]="form.receivingParty" class="form-control"></div>
          </div>
        </div>

        <!-- Type-specific: Lease -->
        <div class="form-card" *ngIf="showLeaseFields">
          <div class="card-header"><span class="material-icons">home_work</span> Lease Details</div>
          <div class="form-grid">
            <div class="form-group full-width"><label>Property Address</label><input type="text" [(ngModel)]="form.propertyAddress" class="form-control"></div>
            <div class="form-group"><label>Lease Term (months)</label><input type="number" [(ngModel)]="form.leaseTermMonths" class="form-control" min="1"></div>
            <div class="form-group"><label>Security Deposit</label><input type="number" [(ngModel)]="form.securityDeposit" class="form-control" min="0"></div>
          </div>
        </div>

        <!-- Type-specific: Employment -->
        <div class="form-card" *ngIf="showEmploymentFields">
          <div class="card-header"><span class="material-icons">work</span> Employment Details</div>
          <div class="form-grid">
            <div class="form-group"><label>Job Title</label><input type="text" [(ngModel)]="form.jobTitle" class="form-control"></div>
            <div class="form-group"><label>Probation Period (months)</label><input type="number" [(ngModel)]="form.probationPeriod" class="form-control" min="0"></div>
            <div class="form-group"><label>Notice Period (days)</label><input type="number" [(ngModel)]="form.noticePeriod" class="form-control" min="0"></div>
            <div class="form-group full-width"><label>Benefits</label><textarea [(ngModel)]="form.benefits" class="form-control" rows="2"></textarea></div>
          </div>
        </div>

        <!-- Type-specific: Maintenance -->
        <div class="form-card" *ngIf="showMaintenanceFields">
          <div class="card-header"><span class="material-icons">settings</span> Maintenance Details</div>
          <div class="form-grid">
            <div class="form-group"><label>Maintenance Schedule</label><input type="text" [(ngModel)]="form.maintenanceSchedule" class="form-control"></div>
            <div class="form-group"><label>Response Time (hours)</label><input type="number" [(ngModel)]="form.responseTime" class="form-control" min="0"></div>
            <div class="form-group full-width"><label>Coverage Scope</label><textarea [(ngModel)]="form.coverageScope" class="form-control" rows="2"></textarea></div>
          </div>
        </div>

        <!-- Type-specific: License -->
        <div class="form-card" *ngIf="showLicenseFields">
          <div class="card-header"><span class="material-icons">vpn_key</span> License Details</div>
          <div class="form-grid">
            <div class="form-group"><label>License Type</label><input type="text" [(ngModel)]="form.licenseType" class="form-control"></div>
            <div class="form-group"><label>Number of Users</label><input type="number" [(ngModel)]="form.numberOfUsers" class="form-control" min="1"></div>
            <div class="form-group"><label>Territory</label><input type="text" [(ngModel)]="form.territory" class="form-control"></div>
            <div class="form-group full-width"><label>Restrictions</label><textarea [(ngModel)]="form.restrictions" class="form-control" rows="2"></textarea></div>
          </div>
        </div>

      </div><!-- /primary-column -->

      <!-- ═══ RIGHT COLUMN ═══════════════════════════════════════════════════ -->
      <div class="form-column secondary-column">

        <!-- Classification -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">tune</span> Classification</div>
          <div class="form-group">
            <label>Priority</label>
            <select [(ngModel)]="form.priority" class="form-control">
              <option *ngFor="let p of priorities" [value]="p">{{ p }}</option>
            </select>
          </div>
          <div class="form-group toggle-row">
            <label>Confidential</label>
            <label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="form.confidential">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>

        <!-- Renewal -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">autorenew</span> Renewal</div>
          <div class="form-group toggle-row">
            <label>Renewable</label>
            <label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="form.isRenewable">
              <span class="toggle-slider"></span>
            </label>
          </div>
          <ng-container *ngIf="form.isRenewable">
            <div class="form-group toggle-row">
              <label>Auto-renew</label>
              <label class="toggle-switch">
                <input type="checkbox" [(ngModel)]="form.autoRenew">
                <span class="toggle-slider"></span>
              </label>
            </div>
            <div class="form-group">
              <label>Renewal Term (months)</label>
              <input type="number" [(ngModel)]="form.renewalTermMonths" class="form-control" min="1">
            </div>
          </ng-container>
        </div>

        <!-- Reminders -->
        <div class="form-card">
          <div class="card-header">
            <span class="material-icons">notifications_active</span> Expiry Reminders
            <button class="btn-icon-sm" (click)="addReminder()" title="Add reminder">
              <span class="material-icons">add</span>
            </button>
          </div>
          <p class="hint-text" *ngIf="!reminders.length && form.expiryDate">
            Default reminders (90/30/7 days) will be generated automatically.
          </p>
          <p class="hint-text" *ngIf="!reminders.length && !form.expiryDate">
            Set an Expiry Date to enable automatic reminders, or add custom ones below.
          </p>
          <div class="reminder-row" *ngFor="let r of reminders; let i = index">
            <input type="text" [(ngModel)]="r.purpose" placeholder="Reminder purpose" class="form-control reminder-purpose">
            <input type="date" [(ngModel)]="r.reminderDate" class="form-control reminder-date">
            <button class="btn-icon-sm danger" (click)="removeReminder(i)"><span class="material-icons">close</span></button>
          </div>
        </div>

        <!-- Notes -->
        <div class="form-card">
          <div class="card-header"><span class="material-icons">note_alt</span> Internal Notes</div>
          <textarea [(ngModel)]="form.internalNotes" class="form-control" rows="4"
                    placeholder="Internal notes about this contract…"></textarea>
        </div>

        <!-- Submit -->
        <div class="form-card submit-card">
          <div class="status-note">
            <span class="material-icons">info</span>
            This contract will be saved with status <strong>Active</strong> — no workflow review required.
          </div>
          <button class="btn btn-primary btn-submit" [disabled]="!isFormValid || isSaving" (click)="submit()">
            <span class="material-icons" *ngIf="!isSaving">upload_file</span>
            <span class="material-icons spinning" *ngIf="isSaving">autorenew</span>
            {{ isSaving ? 'Uploading…' : 'Upload Contract' }}
          </button>
          <button class="btn btn-outline btn-cancel" (click)="goBack()">Cancel</button>
        </div>

      </div><!-- /secondary-column -->

    </div><!-- /upload-form-layout -->
  </main>
</div>
